<template>
	<Button
		icon
		@click="onClick"
		type="light"
		:size="size"
		:disabled="disabled"
		v-tooltip="'Voltar'"
	>
		<template #icon>
			<IconArrowLeft :size="size" />
		</template>
	</Button>
</template>

<script>
import Button from './Button.vue'
import IconArrowLeft from '../icon/IconArrowLeft.vue'
import ButtonMixin from './ButtonMixin.js'
export default {
	mixins: [ButtonMixin],
	components: {
		Button,
		IconArrowLeft
	}
}
</script>
